import AppQR from "../../assets/img/qrcode/QR_AppStore.png";
import React, { useState } from "react";

export default function AppStoreQRCode(props: any) {
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
              <i className="fa-brands fa-apple text-3xl mr-3"></i>
              <br />
              <h3 className="text-3xl font-semibold">AppStore QRコード</h3>
            </div>
            <div className="relative p-6 flex-auto">
              <img src={AppQR} alt="AppStore QRCode" />
            </div>
            <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={props.childAppStoreClose}
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
}
